<template>
  <div id="app">
    <vue-headful :title="'Ironworkers Local ' + chapterNumber"></vue-headful>
    <vk-offcanvas-content>
      <div class="uk-background-muted uk-width-1-1 uk-padding-small uk-margin-large-bottom uk-flex uk-flex-middle uk-flex-between">
        <a :href="'/'">
          <img class="logo" src="./assets/mainLogo.png">
        </a>
        <div>
          <a :href="'/administration/options'" class="adminOptions" v-vk-tooltip.bottom="'Admin Options'" v-if="this.$route.meta['secure'] === true"><vk-icon icon="cog" ratio="1.2"></vk-icon></a>
          <vk-button type="primary" @click="logout" v-if="this.$route.meta['secure'] === true">Log Out</vk-button>
        </div>
      </div>
      <router-view/>
      <div class="uk-background-muted uk-width-1-1 uk-padding uk-margin-large-top">
        <div class="uk-text-right">
          <p>
            <strong>Ironworkers Local 405</strong><br>
            2433 Reed Street<br>
            Philadelphia, Pennsylvania 19146
          </p>
          <p>
            <a href="https://goo.gl/maps/XRin87yagjR2" target="_blank">View on Google Maps</a>
          </p>
        </div>
      </div>
    </vk-offcanvas-content>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      chapterNumber: process.env.CHAPTER_NUMBER
    };
  },
  methods: {
    logout() {
      this.$cookie.delete("iwl_apiToken");
      this.$router.push("/");
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
label,
input {
  display: block;
}
.multiselect__tag,
.multiselect__option--highlight,
.multiselect__option--highlight:after {
  background: #1e87f0 !important;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #0f7ae5 !important;
}
.multiselect__tag-icon:after {
  color: #ffffff !important;
}
.el-input {
  margin-bottom: 20px;
}
.logo {
  max-width: 150px;
  height: auto;
}
.error {
  color: #f0506e;
}
textarea {
  resize: none;
}
.adminOptions,
.adminOptions .uk-icon{
  margin-right:10px;
  color: inherit;
}
.uk-card-body {
  padding: 10px;
  text-align: center;
}
.uk-drop {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue